














import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ButtonSheet extends Vue {
  get slots (): string[] {
    return Object.keys(this.$slots)
  }

  getClickEventName (slot: string): string {
    if (slot === 'default') {
      return 'click'
    }
    return `click:${slot}`
  }
}
